<template>
  <tr class="comparison-plan-table-item-parts">
    <th class="comparison-plan-table-item-parts__label">{{ label }}</th>
    <td class="comparison-plan-table-item-parts__data comparison-plan-table-item-parts__free">
      <div
        v-if="free"
        :class="{ 'comparison-plan-table-item-parts__footnote': freeFootnote1 || freeFootnote2 }"
      >
        <img :src="require('@/assets/img/icon/icon_check_18__gray50.svg')" alt="○" />
        <span v-if="freeFootnote1" class="comparison-plan-table-item-parts__footnote-body">
          ※<span class="comparison-plan-table-item-parts__footnote-number">1</span>
        </span>
        <span v-if="freeFootnote2" class="comparison-plan-table-item-parts__footnote-body">
          ※<span class="comparison-plan-table-item-parts__footnote-number">2</span>
        </span>
      </div>
      <span v-else>-</span>
    </td>
    <td class="comparison-plan-table-item-parts__data comparison-plan-table-item-parts__paid">
      <img v-if="paid" :src="require('@/assets/img/icon/icon_check_18__green_white.svg')" alt="○" />
      <span v-else>-</span>
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * プラン比較テーブル 行パーツ
 */
export default defineComponent({
  name: 'ComparisonPlanTableItemParts',
  props: {
    /**
     * 項目
     */
    label: {
      type: String,
      default: '',
    },
    /**
     * 無料プラン
     */
    free: {
      type: Boolean,
      default: false,
    },
    /**
     * 無料プラン脚注
     */
    freeFootnote1: {
      type: Boolean,
      default: null,
    },
    freeFootnote2: {
      type: Boolean,
      default: null,
    },
    /**
     * 有料プラン
     */
    paid: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss" scoped>
.comparison-plan-table-item-parts {
  color: $gray75;
  border-bottom: 1px solid $black10;

  th,
  td {
    padding: 8px 0;
    vertical-align: middle;
  }

  &__label {
    width: 33.33%;
  }

  &__data {
    width: 33.33%;
    padding: 8px 0;
    text-align: center;

    img {
      width: 28px;
      height: 28px;
    }
  }

  &__footnote {
    position: relative;

    &-body {
      position: absolute;
    }

    &-number {
      font-size: 80%;
    }
  }
}
</style>
